import { localization } from '@ocean/configs'
import { namespace } from 'modules/simulatorTrainings/common/localization'
import {
  ProductSheetSectionContent,
  SectionArguments,
  ProductSheet,
  ProductSheetSection,
} from 'modules/simulatorTrainings/common/types/productSheet'

const { i18n } = localization

const I18_PATH = `${namespace}:simulatorTraining.productSheet`

class ProductSheetUtils {
  normalizeSectionContent(content: ProductSheetSectionContent): string {
    if (!content) return ''
    return typeof content == 'string' ? content : content._
  }

  getSectionTitle(header: string | undefined, sectionKey: string) {
    if (header) return header
    const localizationKey = `${I18_PATH}.titleList.${sectionKey}`
    if (i18n.exists(localizationKey)) return i18n.t(localizationKey)
    return sectionKey.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1')
  }

  getSectionArguments(content: ProductSheetSectionContent) {
    if (!content || typeof content === 'string') return null
    return content.$
  }

  checkSectionIsHidden(sectionArguments: SectionArguments | null) {
    if (!sectionArguments) return false
    const { show } = sectionArguments
    return show === '0'
  }

  parseSection(section: ProductSheetSection) {
    const { type, content } = section
    const sectionArguments = this.getSectionArguments(content)
    const sectionContent = this.normalizeSectionContent(content)
    const isSectionHidden = this.checkSectionIsHidden(sectionArguments)
    const sectionTitle = this.getSectionTitle(sectionArguments?.header, type)
    return { sectionArguments, sectionContent, isSectionHidden, sectionTitle }
  }

  getSectionDetails(sectionName: string, productSheet?: ProductSheet, isMandatory?: boolean) {
    const section: ProductSheetSection = { type: sectionName, content: '' }
    let parsedSection
    if (!productSheet?.hasOwnProperty(sectionName)) {
      parsedSection = this.parseSection(section)
    } else {
      section.content = productSheet[sectionName]
      parsedSection = this.parseSection(section)
    }

    if (isMandatory && !parsedSection.sectionContent) {
      parsedSection.sectionContent = i18n.t(`${I18_PATH}.na`)
    }

    return parsedSection
  }
}

export default new ProductSheetUtils()
